async function checkCamera(check){
    console.log(`${check.title} Check Started`);

	let reply = { isPassed: false, details: "Not Working!" };
	let camera = undefined;
	
	try {
        const cameraId = await localStorageCustom.getItem("ecv-cameraId");
        if(cameraId){
            camera = await navigator.mediaDevices.getUserMedia({ video: { deviceId: cameraId } });
        }
        else {
            camera = await navigator.mediaDevices.getUserMedia({ video: true });
        }
		
		if(camera){
			camera.getTracks().forEach(t => t.stop());
			reply.isPassed = true;
            reply.details = "Detected and Available.";
		}
		else {
            console.error({ camera });
			reply.details = "Please check if you have a secured (HTTPS) connection and your camera is connected and authorized to be used."
		}
	}
	catch(error){
		console.error(error);
		reply.details = error.message;
	}
	
    reply.details = `${check.title}: ${reply.details}`;
    return reply;
}

export default checkCamera;